<template>
    <div :class="[orientation, { 'tab-bar-bordered': border }]" class="tab-bar">
        <div :class="labelsClasses" class="tab-bar-labels" role="tablist">
            <slot/>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import {onBeforeUnmount, watch} from 'vue';
    import {useStore} from 'vuex';

    const props = withDefaults(defineProps<{
        group?: string;
        store?: boolean;
        orientation?: 'horizontal' | 'vertical';
        paramName?: string;
        labelsClasses?: any;
        border?: boolean;
    }>(), {
        group: '',
        store: false,
        orientation: 'horizontal',
        paramName: undefined,
        labelsClasses: undefined,
        border: false,
    });

    const store = useStore();

    function initialize()
    {
        const groupKey = props.group;
        if (groupKey)
        {
            if (store.state.tabBar?.[groupKey])
            {
                return; // already initialized
            }

            store.commit('updateTabBar', {
                group: groupKey,
                data: {
                    store: props.store,
                    paramName: props.paramName,
                },
            });
        }
        else if (props.store || props.paramName)
        {
            throw new Error('no group provided');
        }
    }

    initialize();

    watch(() => props.group, () => initialize());

    onBeforeUnmount(() =>
    {
        if (props.group)
        {
            store.commit('removeTabBar', {group: props.group});
        }
    });
</script>